import { newId } from "../../../src/models/BaseObject";
import type { C1_LegacyEloItemTreeData } from "../types/C1_EloTypes";

/** Deep-clones a legacy ELO tree with fresh IDs, dropping tags and master indices so copied equipment is tagged independently. */
export function cloneEloTreeWithFreshIds(tree: C1_LegacyEloItemTreeData): C1_LegacyEloItemTreeData {
  return {
    ...tree,
    id: newId(),
    tag: undefined,
    masterIndex: undefined,
    items: tree.items.map(cloneEloTreeWithFreshIds),
  };
}
